var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSlots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 7.03125C7.44891 7.03125 8.39484 6.7381 9.17596 6.36401C8.38293 7.85614 7.90778 9.58337 7.81348 11.3646C4.64264 11.705 2.15625 14.3652 2.15625 17.625C2.15625 21.1144 4.99493 24 8.48438 24C9.55939 24 10.5892 23.6971 11.5128 23.1905C10.08 21.7859 9.1875 19.7853 9.1875 17.625C9.1875 15.4647 10.08 13.511 11.5128 12.1064C10.8016 11.7162 10.0267 11.4509 9.21753 11.3478C9.52332 6.37793 13.2766 2.27856 18.1159 1.53058C16.8834 3.26093 16.2188 5.32562 16.2188 7.49341V11.3679C13.0633 11.723 10.5938 14.3762 10.5938 17.625C10.5938 21.1144 13.4324 24 16.9219 24C20.4113 24 23.25 21.1144 23.25 17.625C23.25 14.3762 20.7805 11.723 17.625 11.3679V7.49341C17.625 5.11615 18.5506 2.88116 20.2315 1.20026L21.4318 0H19.7344C16.4319 0 13.4388 1.34674 11.2733 3.5191C10.7047 2.97327 8.88171 1.40625 6.375 1.40625C3.40869 1.40625 1.37897 3.61652 1.28082 3.71063L0.75 4.21875L1.28082 4.72687C1.37897 4.82098 3.40869 7.03125 6.375 7.03125ZM16.9219 15.5156C15.7588 15.5156 14.8125 16.4619 14.8125 17.625H13.4062C13.4062 15.6866 14.9835 14.1094 16.9219 14.1094V15.5156ZM8.48438 15.5156C7.32129 15.5156 6.375 16.4619 6.375 17.625H4.96875C4.96875 15.6866 6.54602 14.1094 8.48438 14.1094V15.5156Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlots);
export default __webpack_public_path__ + "static/media/icon-slots.3adbf32ab42cbd0e026394e19039436e.svg";
export { ForwardRef as ReactComponent };